/**
 * Sentry DSN configurations for different environments
 */
const SENTRY_DSN = {
	PRODUCTION:
		'https://532eab191ebf79b80bfe3f06931ef7d5@o4510115734945792.ingest.us.sentry.io/4510143472205824',
	STAGING:
		'https://52a0296ee6cd34f8c9a5d2929ce026ce@o4510115734945792.ingest.us.sentry.io/4510143472205824',
	DEVELOPMENT:
		'https://e16d5ad15ff3296028c484a604bc836e@o4510115734945792.ingest.us.sentry.io/4510143472205824'
} as const

/**
 * Get Sentry DSN based on current environment
 * @returns The Sentry DSN for the current environment
 */
export const getSentryDSN = (): string => {
	if (process.env.REACT_APP_ENV === 'production') {
		return SENTRY_DSN.PRODUCTION
	}

	if (process.env.REACT_APP_ENV === 'staging') {
		return SENTRY_DSN.STAGING
	}

	return SENTRY_DSN.DEVELOPMENT
}
